import { Icon, IconProps } from '@chakra-ui/react';

export const UnclaimedHouse = (props: IconProps) => {
  return (
    <Icon
      width="170"
      height="85"
      viewBox="0 0 170 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M36.5832 77.098C39.8337 77.098 42.4688 71.8164 42.4688 65.3012C42.4688 58.786 39.8337 53.5044 36.5832 53.5044C33.3326 53.5044 30.6975 58.786 30.6975 65.3012C30.6975 71.8164 33.3326 77.098 36.5832 77.098Z"
          fill="#E6E6E6"
        />
        <path
          d="M37.1269 84.6099C34.7697 70.7168 37.1032 56.8739 37.1271 56.7358L37.5856 56.8121C37.5618 56.9496 35.2417 70.7197 37.5857 84.535L37.1269 84.6099Z"
          fill="#3F3D56"
        />
        <path
          d="M41.7651 62.7636L36.4429 65.5601L36.6623 65.963L41.9845 63.1665L41.7651 62.7636Z"
          fill="#3F3D56"
        />
        <path
          d="M31.0452 64.1653L30.8257 64.5681L36.1473 67.3661L36.3668 66.9633L31.0452 64.1653Z"
          fill="#3F3D56"
        />
        <path
          d="M155.286 0.787109H145.64V33.5889H155.286V0.787109Z"
          fill="#24576B"
        />
        <path
          d="M161.656 27.4185L138.194 0L91.0987 0.423L62.5298 27.7577L63.107 28.1223H62.9009V84.9788H161.593V28.1223L161.656 27.4185Z"
          fill="#24576B"
        />
        <path
          d="M138.219 0.0578613L108.908 33.8142V84.9782H161.593V27.3927L138.219 0.0578613Z"
          fill="#04C2A0"
        />
        <path
          d="M140.816 56.6841H130.057V66.0263H140.816V56.6841Z"
          fill="#3F3D56"
        />
        <path
          d="M140.816 40.5137H130.057V49.7077H140.816V40.5137Z"
          fill="#3F3D56"
        />
        <path
          d="M140.816 56.6841H130.057V66.0263H140.816V56.6841Z"
          fill="white"
        />
        <path
          d="M140.816 40.5137H130.057V49.7077H140.816V40.5137Z"
          fill="white"
        />
        <path
          d="M101.601 83.3114C101.601 83.3114 101.832 78.5636 106.561 79.1154L101.601 83.3114Z"
          fill="#E6E6E6"
        />
        <path
          d="M100.265 78.7934C101.572 78.7934 102.632 77.7525 102.632 76.4686C102.632 75.1846 101.572 74.1438 100.265 74.1438C98.9583 74.1438 97.8987 75.1846 97.8987 76.4686C97.8987 77.7525 98.9583 78.7934 100.265 78.7934Z"
          fill="#04C2A0"
        />
        <path
          d="M100.548 80.384H99.8801V84.9777H100.548V80.384Z"
          fill="#E6E6E6"
        />
        <path
          d="M22.442 70.1802C28.7997 70.1802 33.9537 59.85 33.9537 47.1071C33.9537 34.3641 28.7997 24.0339 22.442 24.0339C16.0844 24.0339 10.9304 34.3641 10.9304 47.1071C10.9304 59.85 16.0844 70.1802 22.442 70.1802Z"
          fill="#04C2A0"
        />
        <path
          d="M23.7237 84.8388C19.1194 57.7014 23.6773 30.6628 23.7238 30.3928L24.1824 30.4691C24.1359 30.7384 19.5914 57.7043 24.1825 84.7639L23.7237 84.8388Z"
          fill="#3F3D56"
        />
        <path
          d="M32.6818 42.3385L22.272 47.8081L22.4914 48.211L32.9012 42.7414L32.6818 42.3385Z"
          fill="#3F3D56"
        />
        <path
          d="M11.5049 45.0781L11.2854 45.481L21.6937 50.9534L21.9132 50.5506L11.5049 45.0781Z"
          fill="#3F3D56"
        />
        <path
          d="M49.7064 64.7943C58.4064 64.7943 65.4591 50.6582 65.4591 33.2205C65.4591 15.7828 58.4064 1.64673 49.7064 1.64673C41.0064 1.64673 33.9536 15.7828 33.9536 33.2205C33.9536 50.6582 41.0064 64.7943 49.7064 64.7943Z"
          fill="#04C2A0"
        />
        <path
          d="M51.5454 84.8385C45.247 47.7168 51.4818 10.7305 51.5455 10.3613L52.004 10.4376C51.9404 10.8062 45.7191 47.7197 52.0041 84.7635L51.5454 84.8385Z"
          fill="#3F3D56"
        />
        <path
          d="M63.759 26.7692L49.5139 34.2539L49.7333 34.6568L63.9784 27.1721L63.759 26.7692Z"
          fill="#3F3D56"
        />
        <path
          d="M34.6997 30.5176L34.4802 30.9204L48.7233 38.4088L48.9428 38.006L34.6997 30.5176Z"
          fill="#3F3D56"
        />
        <path d="M170 84.6028H0V85.0001H170V84.6028Z" fill="#3F3D56" />
        <path
          d="M92.9992 54.2056H82.2395V63.5478H92.9992V54.2056Z"
          fill="#3F3D56"
        />
        <path
          d="M92.9992 38.0354H82.2395V47.2295H92.9992V38.0354Z"
          fill="#3F3D56"
        />
        <path
          d="M92.9992 54.2056H82.2395V63.5478H92.9992V54.2056Z"
          fill="white"
        />
        <path
          d="M92.9992 38.0354H82.2395V47.2295H92.9992V38.0354Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="170" height="85" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};
